


























































































































































import Vue from 'vue'
import { sic, tool } from '@rhitics/core'

export default Vue.extend({
  name: 'BarcodeCard',
  data() {
    return {
      useFile: true,
      form: {
        input: '',
        files: [] as File[],
        loading: false
      },
      stickerList: [] as string[],
      alert: {
        text: '',
        color: 'error',
        switch: false
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.form = {
        input: '',
        files: [],
        loading: false
      }
    },
    async submit() {
      this.form.loading = true
      const isFormInput = this.form.input !== ''

      try {
        if (isFormInput) {
          this.stickerList.push(this.form.input)
        } else {
          const file = this.form.files[0]
          const barcodeNumbers = (await sic.barcode.file(file)).data
          await this.convertPdf(barcodeNumbers)
        }
      } catch (e) {
        this.promoteAlert(true, 'Generate Fail!')
      }

      this.init()
    },
    async convertPdf(values: string[]) {
      this.form.loading = true
      try {
        const barcodes = values.map(value => ({
          template: 'property',
          type: 'datamatrix',
          title: value,
          value,
          quantity: 1
        }))
        const response = await tool.generatePropertySticker(barcodes)
        this.download(response.data.url)
        this.promoteAlert(true, response.data.message, 'success')
      } catch (error) {
        this.promoteAlert(true, 'Generate fail please contect IT. Message: ' + error.message)
      }
      this.form.loading = false
    },
    promoteAlert(open = false, text = '', color = 'error') {
      this.alert.switch = open
      this.alert.text = text
      this.alert.color = color
    },
    download(url: string) {
      var link = document.createElement('a')
      link.target = '_blank'
      link.href = url
      link.click()
    }
  }
})
